//not getting details of logged in user right now

import React, { Component } from 'react';

import leftArrow from '../images/left_arrow.png';

class DetailsPage extends Component {

  constructor(props) {
    super(props);
    this.page_handler = this.page_handler.bind(this);
    this.validateInputEnableNext = this.validateInputEnableNext.bind(this);
    this.state = {
      page_num: 2,
      post_detail_array: [],
      user_id: 0,
      user_name: "",
      user_email: "",
      user_phone: "",
      user_gender: -1,
      click_source: this.props.click_source
    };
  }

  componentDidUpdate(){

  }


  page_handler() {

    document.getElementById("detail_page_main_div").style.display = "none";
    document.getElementById("loader-wrapper-details").style.display = "block";

    let order_hashed_id = this.props.order_id;
    let user_id = 0;
    let user_name = document.getElementById("person_name").value;
    let user_email = document.getElementById("email_id").value;
    let user_phone = document.getElementById("phone_number").value;
    let user_gender = -1;

    if(document.getElementById("person_gender").checked){
      user_gender = 1;
    }else{
      user_gender = 0;
    }
    
    if(user_name !== "" && user_email !== "" && user_phone !== ""){

      var detail_array = {"access_token": this.props.access_token, "ticket_token": this.props.ticket_token,"user_id": user_id, "order_hashed_id": order_hashed_id, "name": user_name, "email": user_email, "phone": user_phone, "gender": user_gender}

      var final_detail_data = JSON.stringify(detail_array);

      fetch('https://checkout-api'+this.props.sandbox_url_creator+'.highape.com/web/v1/post_user_detail', {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: final_detail_data
      })
        .then(function(response) {
            return response.json()
        }).then(function(body) {
            if(body==="Success"){
              this.setState({
                user_id: user_id,
                user_name: user_name,
                user_email: user_email,
                user_phone: user_phone,
                user_gender: user_gender,
                page_num: 3
              });
              document.cookie = 'ref_order_id' + "=" + order_hashed_id + ";path=/;domain=.highape.com";
            }else{
              alert("Something went wrong.");
            }


          if(this.state.page_num === 3  && this.props.page_number===2){
            document.getElementById("detail_page_main_div").style.display = "block";
            document.getElementById("loader-wrapper-details").style.display = "none";
            this.props.main_page_change(this.state.page_num , this.state.user_email, this.state.user_phone);
          }
              
        }.bind(this));

    }else{
      alert("Please fill the required fields to continue.");
      document.getElementById("detail_page_main_div").style.display = "block";
      document.getElementById("loader-wrapper-details").style.display = "none";
    }

  }

  componentDidMount(){
    window.scrollTo(0, 0); //scroll to top on page change
    if(this.props.access_token !== "0"){
      fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/web/v1/get_user_detail?access_token=" + this.props.access_token)
        .then(res => res.json())
        .then(
          (result) => {
          	if (result['email'].length > 4){
	            document.getElementById("email_id").value = result['email'];
	            document.getElementById("phone_number").value = result['phone'];
	            document.getElementById("person_name").value = result['name'];
	            if(result['gender']===1){
	              document.getElementById("person_gender").checked = true;
	            }

	            this.validateInputEnableNext("email");
	            this.validateInputEnableNext("phone");
	            this.validateInputEnableNext("person_name");
        	}	

          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
          }
        );
    }
  }

  render() {
    return (
        <div>
          <LoadingDiv />
          <div className={this.props.name_of_class} id="detail_page_main_div">
            <div className="col-sm-12 col-xs-12">
              <form>
                <div id="input_buttons_div">
                  <div className="input_form_div">
                    <input type="email" name="email_id" autoComplete="email" className="input_form" id="email_id" onBlur={() => this.validateInputEnableNext("email")} required />
                    <label htmlFor="email_id"><span>Email Address</span></label>
                    <span id="error_email" className="details_page_error">Please enter a valid email.</span>
                    <span id="email_valid_span" className="valid_span_default">0</span>
                  </div>
                  <div className="clearfix"></div>
                  <div className="input_form_div">
                    <input type="number" name="phone_number" autoComplete="tel-national" className="input_form" id="phone_number" onBlur={() => this.validateInputEnableNext("phone")} required />
                    <label htmlFor="phone_number"><span>Phone Number</span></label>
                    <span id="error_phone" className="details_page_error">Please enter a valid 10 digit mobile number.</span>
                    <span id="phone_valid_span" className="valid_span_default">0</span>
                  </div>
                  <div className="clearfix"></div>
                  <div className="input_form_div">
                    <input type="text" name="person_name" autoComplete="off" className="input_form" id="person_name" onChange={() => this.validateInputEnableNext("person_name")} required />
                    <label htmlFor="person_name"><span>Name</span></label>
                    <span id="name_valid_span" className="valid_span_default">0</span>
                  </div>
                </div>
                <div className="clearfix"></div>
                <div id="checkbox_div" className="input_form_div">
                  <span className="male_female_span female_span">Female</span><label className="switch">
                    <input type="checkbox" id="person_gender" />
                    <div className="slider"></div>
                  </label><span className="male_female_span male_span">Male</span>
                </div>
              </form>
            </div>
            <FooterTickets page_change={this.page_handler} do_validation={() => this.validateInputEnableNext("person_name")}/>
          </div>
        </div>
       
    );
  }

  validateInputEnableNext(validate_what){
    //alert("hey");

    if(validate_what==="email"){
      if(document.getElementById("email_id") != null) {

        let email = document.getElementById("email_id").value;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(re.test(String(email).toLowerCase())){

          let error_text = document.getElementById("error_email");
          error_text.classList.remove("show_block");
          document.getElementById("email_valid_span").innerText = 1;
          if(document.getElementById("email_valid_span").innerText === "1" && document.getElementById("phone_valid_span").innerText === "1" && document.getElementById("name_valid_span").innerText === "1"){
            //alert("Good to go");
            document.getElementById("next_details_click_disabled").style.display = "none";
            document.getElementById("next_details_click_enabled").style.display = "block";
          }else{
            document.getElementById("next_details_click_enabled").style.display = "none";
            document.getElementById("next_details_click_disabled").style.display = "block";
          }
        }else{
          let error_text = document.getElementById("error_email");
          error_text.classList.add("show_block");
          document.getElementById("email_valid_span").innerText = 0;
          document.getElementById("next_details_click_enabled").style.display = "none";
          document.getElementById("next_details_click_disabled").style.display = "block";
        }

      }else{
        alert("Please enter a valid Email ID");
      }

    }else if(validate_what==="phone"){
      if(document.getElementById("phone_number") != null) {
        let phone_number = document.getElementById("phone_number").value;
        let re = /^\d{10}$/;
        if(re.test(phone_number)){
          let error_text = document.getElementById("error_phone");
          error_text.classList.remove("show_block");
          document.getElementById("phone_valid_span").innerText = 1;
          if(document.getElementById("email_valid_span").innerText === "1" && document.getElementById("phone_valid_span").innerText === "1" && document.getElementById("name_valid_span").innerText === "1"){
            //alert("Good to go");
            document.getElementById("next_details_click_disabled").style.display = "none";
            document.getElementById("next_details_click_enabled").style.display = "block";
          }else{
            document.getElementById("next_details_click_enabled").style.display = "none";
            document.getElementById("next_details_click_disabled").style.display = "block";
          }
        }else{
          let error_text = document.getElementById("error_phone");
          error_text.classList.add("show_block");
          document.getElementById("phone_valid_span").innerText = 0;
          document.getElementById("next_details_click_enabled").style.display = "none";
          document.getElementById("next_details_click_disabled").style.display = "block";
        }
      }else{
        alert("Please enter a valid mobile number.");
      }

    }else if(validate_what==="person_name"){
      if(document.getElementById("person_name") != null){

        if(document.getElementById("person_name").value.length>2){
          document.getElementById("name_valid_span").innerText = 1;
          if(document.getElementById("email_valid_span").innerText === "1" && document.getElementById("phone_valid_span").innerText === "1" && document.getElementById("name_valid_span").innerText === "1"){
            //alert("Good to go");
            document.getElementById("next_details_click_disabled").style.display = "none";
            document.getElementById("next_details_click_enabled").style.display = "block";
          }else{
            document.getElementById("next_details_click_enabled").style.display = "none";
            document.getElementById("next_details_click_disabled").style.display = "block";
          }
        }else{
          document.getElementById("name_valid_span").innerText = 0;
          document.getElementById("next_details_click_enabled").style.display = "none";
          document.getElementById("next_details_click_disabled").style.display = "block";
        }

        this.validateInputEnableNext("phone");
        this.validateInputEnableNext("email");
      }else{
        alert("Please enter your valid details first.");
      }

    }

  }
}

class LoadingDiv extends Component {
  
  render() {

      return (<div id="loader-wrapper-details">
                  <div id="fountainG">
                    <div id="fountainG_1" className="fountainG"></div>
                    <div id="fountainG_2" className="fountainG"></div>
                    <div id="fountainG_3" className="fountainG"></div>
                    <div id="fountainG_4" className="fountainG"></div>
                    <div id="fountainG_5" className="fountainG"></div>
                    <div id="fountainG_6" className="fountainG"></div>
                    <div id="fountainG_7" className="fountainG"></div>
                    <div id="fountainG_8" className="fountainG"></div>
                  </div>
              </div>
             );
  }
}

class FooterTickets extends Component {
  render() {
    return (
      <div>
        <div className="col-sm-12 col-xs-12 next_details_click" id="next_details_click_disabled" onClick={this.props.do_validation}>
          Continue
        </div>
        <div className="col-sm-12 col-xs-12 next_details_click next_details_red" id="next_details_click_enabled" onClick={this.props.page_change}>
          Continue
        </div>
        <div className="clearfix"></div>
        <div className="ticket_desktop_footer col-sm-12 col-xs-12">
              <p className="below_continue_back_mob" onClick={() => this.triggerHeaderClick()} ><img src={leftArrow} className="left_back_icon" alt="Left Arrow Icon"/>Back</p>
        </div>
      </div>
    );
  }

triggerHeaderClick() {
  document.getElementById("first_journey_main").click();
}

}

export default DetailsPage;


// WEBPACK FOOTER //
// ./src/mobile/mobDetailsPage.js